module.exports = __webpack_public_path__ + "img/组 113@2x.0eb34648.png";